import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import ProjectWaitingForCloseForm from './ProjectWaitingForCloseForm'
import TableReport from '../tableReport/TableReport'
import {
  searchProjectWaitingForClose,
  downloadProjectWaitingForClose,
} from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import moment from 'moment'

export default function ProjectWaitingForCloseWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load ProjectName projectId', projectId, formSchema)
    //setDataTable(mockCallData)
  }, [])

  const onSubmit = (data) => {
    console.log('onPreview', data)

    let request = {
      // fromDate: data.startDate,
      // toDate: data.endDate,
      fromDate: data.startDate ? moment(data.startDate).format('yyyy-MM-DD') : null,
      toDate: data.endDate ? moment(data.endDate).format('yyyy-MM-DD') : null,
      departmentCode: data.department,
      projectCode: data.projectCode,
      projectName: data.projectName,
      budgetStartYear: data.budgetYearStart || null,
      budgetEndYear: data.budgetYearEnd || null,
      pageNumber: 1,
      pageSize: pagSize,
    }

    setCondition(data)
    handlePreviewReport(request)
  }

  const handleSubmitOnPrint = (data) => {
    console.log('handleSubmitOnPrint ', data)

    let request = {
      fromDate: data.startDate,
      toDate: data.endDate,
      departmentCode: data.department,
      projectCode: data.projectCode,
      projectName: data.projectName,
      budgetStartYear: data.budgetYearStart || null,
      budgetEndYear: data.budgetYearEnd || null,
    }

    setCondition(data)
    handleDownloadReport(request)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      fromDate: condition.startDate || '',
      toDate: condition.endDate || '',
      departmentCode: condition.department || '',
      projectCode: condition.projectCode || '',
      projectName: condition.projectName || '',
      budgetStartYear: condition.budgetYearStart || null,
      budgetEndYear: condition.budgetYearEnd || null,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handleCancel = () => {
    console.log('handleCancel ', formSchema)

    // const objInput = document.getElementsByClassName('clear-data')
    // for (let i = 0; i < objInput.length; i++) {
    //   objInput[i].value = ''
    // }

    setValueNullField()
    setDataTable(null)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchProjectWaitingForClose(request)
      console.log('response', response)

      if (response.model) {
        const arrLength = response.model.tableColumns.length
        if (response.model.tableColumns[arrLength - 1].dataKey === 'rowNumber') {
          response.model.tableColumns.reverse()
        }

        setDataTable(response.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await downloadProjectWaitingForClose(request)

      console.log('response', file)
      if (file) {
        downloadFile(file, file.name || `รายงาน${formSchema.reportName}`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      console.log('error ', e)
      // let errorJson = JSON.parse(await e.response.data.text())
      // setIsError(true)
      // handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <>
            <ProjectWaitingForCloseForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              // handelPreview={onSubmit}
              clearValue={clearValue}
            />

            <hr />

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema.buttonText}
              onPreview={handleSubmit(onSubmit)}
              onPrint={handleSubmit(handleSubmitOnPrint)}
              onCancel={handleSubmit(handleCancel)}
              // onCancel={(el) => {
              //   console.log('el ', el.target)
              //   // setIsError(false)
              //   // location.reload()
              // }}
            />
          </>
        )}
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <TableReport
            schema={dataTable}
            Controller={Controller}
            control={control}
            pagination={true}
            loading={isLoading}
            onReload={handelGetSchemaOnReload}
          />
          <br />
        </>
      )}
    </>
  )
}
